import React, { useEffect, useState } from "react";
import { CircleUserRound, ChevronRight, Search } from "lucide-react";
import {  useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../redux/store";
import { useSelector } from "react-redux";
import { getGeoTrackingList } from "../../../redux/features/geoTracking";


const GeoTrackingList: React.FC = () => {
  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);

  // Format to YYYY-MM-DD
  const formatDate = (date: Date) => date.toISOString().split("T")[0];

  const [startDate, setStartDate] = useState<string>(formatDate(oneMonthAgo));
  const [endDate, setEndDate] = useState<string>(formatDate(today));
  const [search, setSearch] = useState<string>("");
  const dispatch = useAppDispatch();
  const user = useSelector((state: any) => state?.user?.user);
  const { geoTrackingList } = useSelector((state: any) => state?.geoTracking);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(
      getGeoTrackingList({
        start_date: startDate,
        end_date: endDate,
      })
    );
  }, [dispatch, user.id, startDate, endDate]);

  return (
    <div className="max-w-full mx-4 border rounded-xl">
      <div className="grid grid-cols-2 gap-4 p-4">
        <div>
          <label className="block text-sm font-medium mb-1">Date Start</label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="w-full border rounded-md px-3 py-2"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Date End</label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="w-full border rounded-md px-3 py-2"
          />
        </div>
      </div>

      <div className="px-4 pb-4">
        <label className="block text-sm font-medium mb-1">Employee</label>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
          <input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full pl-10 border rounded-md px-3 py-2"
          />
        </div>
        <button className="w-full bg-gray-200 text-black py-2 mt-4 border border-gray-500 rounded-md font-medium">
          Search
        </button>
      </div>

      <hr />

      <div>
        {/* Mobile View */}
        <div className="md:hidden">
          {Array.isArray(geoTrackingList?.data) &&
            geoTrackingList?.data.map((item: any, index: number) => (
              <div
                key={item?.tracking_uuid}
                className={`flex justify-between items-center p-4 ${
                  index !== geoTrackingList?.data?.length - 1 ? "border-b" : ""
                }`}
                onClick={() =>
                  navigate("/m-view-on-map", {
                    state: {
                      tracking_uuid: item?.tracking_uuid,
                      tracking_data:item
                    },
                  })
                }
              >
                <div>
                  <div className="font-semibold">
                    {item?.emp_detail?.emp_name}
                  </div>
                  <div className="text-sm text-gray-600">
                    {item.os_emp_start_datetime}
                  </div>
                  <div className="text-sm">{item?.site?.name}</div>
                </div>
                <div className="flex flex-col items-end justify-between">
                  {/* <Link to="/test-view-on-map"> */}
                  <ChevronRight className="text-xl text-gray-500 cursor-pointer hover:text-gray-700 transition" />
                  {/* </Link> */}
                  <div className="text-sm">
                    {item?.shift?.start_time}-{item?.shift?.end_time}
                  </div>
                </div>
              </div>
            ))}
        </div>

        {/* Desktop View */}
        <div className="hidden md:table w-full text-sm border border-gray-300 border-collapse">
          <div className="table-header-group bg-gray-100 font-medium">
            <div className="table-row">
              <div className="table-cell border border-gray-300 px-4 py-2">
                Employee
              </div>
              <div className="table-cell border border-gray-300 px-4 py-2">
                Date
              </div>
              <div className="table-cell border border-gray-300 px-4 py-2">
                Site
              </div>
              <div className="table-cell border border-gray-300 px-4 py-2">
                Shift
              </div>
            </div>
          </div>
          <div className="table-row-group">
            {Array.isArray(geoTrackingList?.data) &&
              geoTrackingList?.data.map((item: any, index: number) => (
                <div
                  key={item?.tracking_uuid}
                  className="table-row"
                  onClick={() =>
                    navigate("/m-view-on-map", {
                      state: {
                        tracking_uuid: item?.tracking_uuid,
                      },
                    })
                  }
                >
                  <div className="table-cell border border-gray-300 px-4 py-2">
                    <div className="flex items-center gap-2">
                      <CircleUserRound className="text-gray-500" />
                      {item?.emp_detail?.emp_name}
                    </div>
                  </div>
                  <div className="table-cell border border-gray-300 px-4 py-2">
                    {item.os_emp_start_datetime}
                  </div>
                  <div className="table-cell border border-gray-300 px-4 py-2">
                    {item?.site?.name}
                  </div>
                  <div className="table-cell border border-gray-300 px-4 py-2">
                    {item?.shift?.start_time}-{item?.shift?.end_time}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeoTrackingList;
